import React from 'react';
import importAllImg from "../helpers/import-all-imgs";
import {useIntl} from "react-intl";

const imgs = importAllImg(require.context('../img/npf', false, /\.(png|jpe?g|svg)$/));

function Partnerships({ partnerships }) {
  const { formatMessage } = useIntl();
  const fm = id => formatMessage({id});

  return (
    <div className='bg-white py-4 md:py-10 px-5 md:px-[7.5%]'>
      <h2 className='text-lg md:text-3xl font-bold text-center mb-4 md:mb-12 text-black'>
        {fm('PARTNERSHIPS')}
      </h2>

      {/* Desktop Grid */}
      <div className='hidden md:grid md:grid-cols-3 gap-x-16 gap-y-8'>
        {partnerships.map((partnership, index) => (
          <div
            key={index}
            className='bg-white rounded-2xl border border-gray-200 overflow-hidden flex flex-col'
          >
            {/* Status Badge */}
            {partnership.status && (
              <div className={`px-4 py-2 text-center ${partnership.status === 'ongoing' ? 'bg-[rgba(133,170,5,0.4)]' : 'bg-[rgba(130,130,130,0.4)]'}`}>
                <span className='text-sm text-white font-semibold uppercase'>
                  {partnership.status === 'ongoing' ? fm('ONGOING') : fm('COMPLETED')}
                </span>
              </div>
            )}

            {/* Content */}
            <div className='p-6 flex-1 flex flex-col bg-[#F2F2F7]'>
              {/* Logo */}
              <div className='mb-4 h-20 flex items-center'>
                <img
                  src={imgs[partnership.logo]}
                  alt={fm(partnership.titleKey)}
                  className='max-h-20 w-auto object-contain'
                />
              </div>

              {/* Title */}
              <h3 className='text-lg font-bold mb-3 text-black uppercase'>
                {fm(partnership.titleKey)}
              </h3>

              {/* Description */}
              {partnership.descriptionKeys ? (
                <div className='text-sm text-gray-700 leading-relaxed mb-4 flex-1 space-y-3'>
                  {partnership.descriptionKeys.map((descKey, descIndex) => (
                    <p key={descIndex}>
                      {fm(descKey)}
                    </p>
                  ))}
                </div>
              ) : partnership.descriptionKey ? (
                <p className='text-sm text-gray-700 leading-relaxed mb-4 flex-1'>
                  {fm(partnership.descriptionKey)}
                </p>
              ) : null}

            </div>
            {/* Learn More Button */}
            {partnership.url && (
              <button
                onClick={() => window.open(partnership.url, '_blank')}
                className='uppercase w-full bg-[#354402] text-white px-4 py-2 rounded-bl-lg rounded-br-lg text-sm font-semibold hover:bg-[#2a3501] transition-colors flex justify-center items-center gap-2'
              >
                {fm('Learn more →')}
              </button>
            )}
          </div>
        ))}
      </div>

      {/* Mobile List */}
      <div className='block md:hidden space-y-3'>
        {partnerships.map((partnership, index) => (
          <div
            key={index}
            onClick={() => partnership.url && window.open(partnership.url, '_blank')}
            className={`bg-[#F2F2F7] h-[51px] flex items-stretch ${partnership.url ? 'cursor-pointer' : ''}`}
            style={{ borderRadius: '12px 0 0 12px', overflow: 'hidden' }}
          >
            {/* Colored Block - Leftmost with rounded corners */}
            <div
              className={`w-[50px] flex-shrink-0 ${
                partnership.status
                  ? partnership.status === 'ongoing' ? 'bg-[#D2E3AA]' : 'bg-[#CCCCCC]'
                  : 'bg-[#D2E3AA]'
              }`}
              style={{
                borderTopLeftRadius: '12px',
                borderBottomLeftRadius: '12px',
                borderTopRightRadius: '0',
                borderBottomRightRadius: '0'
              }}
            ></div>

            {/* Title */}
            <div className='flex-1 px-4 py-4 flex items-center'>
              <h3 className='text-sm font-bold text-black uppercase leading-tight mb-0'>
                {fm(partnership.titleKey)}
              </h3>
            </div>

            {/* Arrow Icon */}
            {partnership.url && (
              <div className='pr-4 flex-shrink-0 flex items-center'>
                <img
                  src={imgs['arrow-down-right-svgrepo-com 14.svg']}
                  alt="Learn more"
                  className='w-5 h-5'
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Partnerships;
